import { TranslateService } from '@ngx-translate/core';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { OperationMode } from 'src/app/shared/models/enum.model';
import { AddPeriodModel } from './../../shared/models/period.model';
import {
  AddPeriod,
  EditPeriod,
} from './../../shared/ngxs/action/period.action';
import { ConversionService } from './../../shared/services/conversion.service';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD MMM YYYY',
  },
  display: {
    dateInput: 'DD MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-manage-period',
  templateUrl: './manage-period.component.html',
  styleUrls: ['./manage-period.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class ManagePeriodComponent implements OnInit {
  model = new AddPeriodModel();
  title = 'Add';
  opModes = OperationMode;
  opMode = OperationMode.Create;
  confirmationBtnText = '';
  cancelBtnText = 'Cancel';

  group: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store,
    private conversionService: ConversionService,
    private formBuilder: FormBuilder,
    private translateService: TranslateService
  ) {
    if (data) {
      if (data.model) {
        this.model = data.model;
      }
      this.opMode = data.mode;

      this.confirmationBtnText =
        this.opMode === OperationMode.Create ? 'Create' : 'Update';
      this.title = this.opMode === OperationMode.Create ? 'Add' : 'Edit';
    }

    this.group = this.formBuilder.group({
      id: [this.model.id],
      name: [this.model.name, Validators.required],
      from: [this.model.from, Validators.required],
      to: [this.model.to, Validators.required],
    });
  }

  setAcceptFiles() {
    return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  }

  onFileChange(event: any) {
    if (event.target.files && event.target.files.length) {
      const reader = new FileReader();
      const [file] = event.target.files;
      reader.onload = () => {
        var base64Data = reader.result.toString();
      };
      // Read the file
      reader.readAsDataURL(file);
    }
  }

  ngOnInit(): void {}

  periodToSelected(event: any) {
    this.group.controls['to'].setValue(event);
  }

  periodFromSelected(event: any) {
    this.group.controls['from'].setValue(event);
  }

  onConfirm() {
    const model = new AddPeriodModel();

    model.id = this.group.controls['id'].value;
    model.name = this.group.controls['name'].value;
    model.language = this.translateService.currentLang;
    model.from = this.conversionService.getDateFormatForInsert(
      new Date(this.group.controls['from'].value)
    );
    model.to = this.conversionService.getDateFormatForInsert(
      new Date(this.group.controls['to'].value)
    );

    if (this.opMode === OperationMode.Create) {
      this.store.dispatch(new AddPeriod(model));
    } else if (this.opMode === OperationMode.Edit) {
      this.store.dispatch(new EditPeriod(model));
    }
  }
}
